import Types from './type'

/**
 * @param {*} typeName 键值常量名
 * @param {*} value 值
 */
export const storeSet = (typeName, value) => {
  try {
    if (!typeName || !Types[typeName] || !localStorage) return
    localStorage.setItem(Types[typeName], value)
  } catch (error) {
    console.log(error)
  }
}

/**
 * @param {*} typeName 键值常量名
 */
export const storeGet = (typeName) => {
  try {
    if (!typeName || !Types[typeName] || !localStorage) return ''
    return localStorage.getItem(Types[typeName])
  } catch (error) {
    return ''
  }
}

/**
 * @param {*} typeName 键值常量名
 */
export const storeDel = (typeName) => {
  try {
    if (!typeName || !Types[typeName] || !localStorage) return
    localStorage.removeItem(Types[typeName])
  } catch (error) {
    console.log(error)
  }
}
